import React, { ReactElement } from 'react';
import { css } from '@emotion/react';
import { TextareaField } from '@bucketplace/commerce-admin-ui';

import { FormContent, InspectorFormProvider } from '../../components';
import { DocumentInspectorProps } from '../../types';
import { HTMLTemplateProps } from './HTMLTemplate';

export function HTMLTemplateInspector({
  value,
  onChange,
}: DocumentInspectorProps<HTMLTemplateProps>): ReactElement {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <FormContent header="내용" direction="VERTICAL">
        <TextareaField
          name="contents"
          width="100%"
          placeholder="HTML로 된 내용을 입력해주세요."
          autoHeight
          customCss={css`
           textarea {
              min-height: 240px;
            }
          `}
        />
      </FormContent>
    </InspectorFormProvider>
  );
}

